import type { JSX } from 'react';

import { CheckIcon, LinkIcon } from '@change/ds-icons';

import { Button } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

import type { Props as MainProps } from '../../index';

import { useShareUrl } from './hooks/useShareUrl';

export function ShareUrlReskin({ viewContext }: { viewContext: MainProps['viewContext'] }): JSX.Element {
	const { data, actions } = useShareUrl(viewContext);

	return (
		<Button
			data-testid="copy-link-share-button"
			data-qa="copy-link-share-button"
			onClick={actions.handleShare}
			size="x-small"
			variant="secondary-solid"
			leadingIcon={
				data.copied ? (
					<CheckIcon
						data-testid="copy-link-icon-success"
						data-qa="copy-link-icon"
						aria-label="Link Copied"
						className="text-icon-success"
					/>
				) : (
					<LinkIcon
						data-testid="copy-link-icon"
						data-qa="copy-link-icon"
						aria-label="Copy Link"
						className="text-typography-strong"
					/>
				)
			}
			className="w-full md:w-auto"
		>
			<div className="flex flex-row items-center gap-1">
				{data.copied ? (
					<Translate value="corgi.petition.starter_dashboard.recommendations.copy_link.copy_success" />
				) : (
					<Translate value="corgi.petition.starter_dashboard.recommendations.copy_link.copy_button" />
				)}
			</div>
		</Button>
	);
}
